module.exports = __webpack_public_path__ + "static/media/Token-Legal-Contract_Placeholder.a8304e86.pdf";